<template>
  <div class="swiper" v-if="videoList.length">
    <swiper
      :options="swiperOption"
      ref="mySwiper"
      v-if="init"
      @swiper="onSwiper"
      @slideChange="onSlideChange"
    >
      <swiper-slide class="swiper_slide" v-for="(t, i) in videoList" :key="i">
        <div>
          <img :src="t.kvImg" alt="" />
        </div>
        <!-- <img src="@/assets/KV.jpg" alt=""> -->
      </swiper-slide>
    </swiper>
    <div class="swiper-pagination"></div>
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
  </div>
</template>

<script>
let that = null
export default {
  created() {
    that = this
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 'auto',
        centeredSlidesBounds: true,
        effect: 'coverflow',
        centeredSlides: true,
        initialSlide: 0,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        // autoplay: {
        //   delay: 2000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false
        // },
        coverflowEffect: {
          rotate: -100,
          stretch: 120,
          depth: 340,
          modifier: 1,
          slideShadows: true
        },
        // coverflowEffect: {
        //   rotate: -70,
        //   stretch: 65,
        //   depth: 400,
        //   modifier: 1,
        //   slideShadows: true
        // },
        loop: true,
        on: {
          tap: function (e) {
            var index = e.realIndex
            var item = that.videoList[index]
            that.selectLive(item)
          }
        }
      },
      init: true,
      swiperObj: {},
      slider: []
    }
  },
  props: {
    videoList: {
      type: Array,
      default: () => {
        return []
      }
    },
    liveId: {
      type: Number || String,
      default: null
    }
  },
  watch: {
    videoList(n) {
      this.init = false
      setTimeout(() => {
        this.init = true
      }, 10)
    }
  },
  mounted() {},
  methods: {
    // 选择直播
    selectLive(data) {
      // 直播ID
      console.log(data.liveId)
      this.$emit('update:liveId', data.liveId)
    },
    onSwiper() {},
    onSlideChange() {}
  }
}
</script>

<style lang="scss" scoped>
.swiper {
  width: 95%;
  margin: auto;
  overflow: hidden;
}
.swiper-button-next::after,
.swiper-button-prev::after {
  font-size: 0.3rem !important;
  color: #fff;
}
.swiper_slide {
  width: 80% !important;
  img {
    width: 100%;
    cursor: pointer;
  }
}
</style>
